import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getOrderRequest } from '../../store/order/actions/order-actions';
import OrderDetailsSection from './components/OrderDetailsSection';
import { useApplyFieldErrors } from '../../hooks/useApplyFieldErrors';

const OrderDetailsPage = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const { order, error, productSnapshotCreationStatus } = useSelector((state) => state.orderData);

    const fieldErrors = error?.fieldErrors ?? [];
    useApplyFieldErrors(fieldErrors);

    useEffect(() => {
        dispatch(getOrderRequest(id));
    }, [dispatch, id]);

    if (!order) return <div className="p-4">Loading...</div>;

    return (
        <div className="container mx-auto p-4">
            <OrderDetailsSection
                order={order}
                error={error}
                productSnapshotCreationStatus={productSnapshotCreationStatus}
            />
        </div>
    );
};

export default OrderDetailsPage;